// src/components/PrivateRoute.js
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { Navigate } from "react-router-dom";
import { logger } from "../utils/logger";

const PrivateRoute = ({ children, allowedRoles }) => {
  const { isAuthenticated, role } = useSelector((state) => state.auth);
  const location = useLocation();
  const user = JSON.parse(sessionStorage.getItem("user")) || {};

  useEffect(() => {
    logger.info("Page viewed", {
      path: location.pathname,
      username: user.username,
      role: user.role,
    });
  }, [location.pathname]);

  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  // Check if the user's role is allowed to access this route
  if (allowedRoles && !allowedRoles.includes(role)) {
    return <Navigate to="/dashboard" />; // Redirect if unauthorized
  }

  return children;
};

export default PrivateRoute;
